import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ngx-password-reset-validation',
    templateUrl: './password-reset-validation.component.html',
    styleUrls: ['./password-reset-validation.component.scss'],
    standalone: false
})
export class PasswordResetValidationComponent implements OnInit {
  status: string | null = null;
  message: string | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.status = params['status'];
      this.message = params['message'];
    });
  }
}
